import { SVGProps } from 'react'

const SvgSingleSensorFilledAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M12 2a1 1 0 0 0-1 1v1H8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3v5a1 1 0 1 0 2 0v-5a4 4 0 0 1 4-4h1V6a2 2 0 0 0-2-2h-3V3a1 1 0 0 0-1-1zm0 5a2.995 2.995 0 0 1 3 3 3.002 3.002 0 0 1-4 2.83A3.002 3.002 0 0 1 12 7zm7 7a.968.968 0 0 0-.713.287A.968.968 0 0 0 18 15v2h-2a.968.968 0 0 0-.713.287c-.192.192-.287.43-.287.713s.095.521.287.713c.192.192.43.287.713.287h2v2c0 .283.095.521.287.713.192.192.43.287.713.287s.521-.095.713-.287A.968.968 0 0 0 20 21v-2h2a.968.968 0 0 0 .713-.287c.192-.192.287-.43.287-.713s-.095-.521-.287-.713A.968.968 0 0 0 22 17h-2v-2a.968.968 0 0 0-.287-.713A.968.968 0 0 0 19 14z' />
  </svg>
)

export default SvgSingleSensorFilledAdd
